import { Routes } from '@angular/router';
import {CustomerComponent} from "./customer.component";
import { PermissionGuard } from '../security/permission.guard';
import { app_permissions } from '../security/app-permissions';

export const customerRoutes: Routes = [
    {
        path: 'customer',
        children: [
            {
                path: '',
                component: CustomerComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.customer.records.view }
            },
            {
                path: ':id',
                component: CustomerComponent,
                canActivate: [PermissionGuard],
                data: { permission: app_permissions.customer.records.view }
            }
        ]
    },
];
